import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'

interface PackageDetailsProps {
  onDetailsClick?: () => void
}

const containerStyles = {
  p: 2,
  borderBottom: '2px solid #F6F4F4',
  cursor: 'pointer',
}

const clickableRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 0.5,
}

const titleStyles = {
  fontSize: '16px',
  fontWeight: 600,
  color: '#1D1A33',
  lineHeight: '150%',
  letterSpacing: '0.15px',
}

const arrowIconStyles = {
  color: '#929292',

}

export const PackageDetails = ({ onDetailsClick }: PackageDetailsProps) => {
  return (
    <Box sx={containerStyles} onClick={onDetailsClick}>
      <Box sx={clickableRowStyles}>
        <Typography variant='h6' sx={titleStyles}>
          Package details
        </Typography>
        <KeyboardArrowDownIcon fontSize='large' sx={arrowIconStyles} />
      </Box>
    </Box>
  )
}
